var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgModelIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4V11.3776H10.7908V6.61224C10.7908 6.42177 10.801 6.21599 10.8214 5.9949L8.59184 10.1837C8.48639 10.3844 8.32483 10.4847 8.10714 10.4847H7.91327C7.69558 10.4847 7.53401 10.3844 7.42857 10.1837L5.17347 5.97959C5.18367 6.09184 5.19218 6.20238 5.19898 6.31122C5.20578 6.42007 5.20918 6.52041 5.20918 6.61224V11.3776H4V4H5.03571C5.09694 4 5.14966 4.0017 5.19388 4.0051C5.2381 4.0085 5.27721 4.01701 5.31122 4.03061C5.34864 4.04422 5.38095 4.06633 5.40816 4.09694C5.43878 4.12755 5.46769 4.16837 5.4949 4.21939L7.70408 8.31633C7.7619 8.42517 7.81463 8.53741 7.86224 8.65306C7.91327 8.76871 7.96258 8.88775 8.0102 9.0102C8.05782 8.88435 8.10714 8.76361 8.15816 8.64796C8.20918 8.52891 8.26361 8.41497 8.32143 8.30612L10.5 4.21939C10.5272 4.16837 10.5561 4.12755 10.5867 4.09694C10.6173 4.06633 10.6497 4.04422 10.6837 4.03061C10.7211 4.01701 10.7619 4.0085 10.8061 4.0051C10.8503 4.0017 10.9031 4 10.9643 4H12Z",
    fill: "#5B8DB4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3 8C15.3 12.0317 12.0317 15.3 8 15.3C3.96832 15.3 0.7 12.0317 0.7 8C0.7 3.96832 3.96832 0.7 8 0.7C12.0317 0.7 15.3 3.96832 15.3 8Z",
    stroke: "#5B8DB4",
    strokeWidth: 1.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModelIcon);
export default __webpack_public_path__ + "static/media/model-icon.2e0424462a1f6c15b727bf8d096e4acf.svg";
export { ForwardRef as ReactComponent };